import { useEffect, useState } from 'react';
import { useWorkflows } from '@/store/workflows';
import { api } from '@/lib/api';

export function ReviewModal() {
  const open = useWorkflows((s) => s.workflows.find((w) => w.pendingReview));
  const setPendingReview = useWorkflows((s) => s.setPendingReview);
  const pushToast = useWorkflows((s) => s.pushToast);
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [busy, setBusy] = useState(false);
  const review = open?.pendingReview ?? null;

  useEffect(() => {
    if (review) {
      setTitle(review.title);
      setDesc(review.description);
    }
  }, [review?.clipId, review]);

  if (!open || !review) return null;
  const wf = open;

  async function approve() {
    if (!wf.streamerHandle || !review) return;
    setBusy(true);
    try {
      await api.triggerUpload(wf.streamerHandle, review.clipId);
      setPendingReview(wf.id, null);
      pushToast('approved → publishing', wf.id);
    } catch (e) {
      pushToast(`publish failed: ${(e as Error).message.slice(0, 80)}`, wf.id);
    } finally {
      setBusy(false);
    }
  }

  async function redo() {
    if (!wf.streamerHandle || !review) return;
    setBusy(true);
    try {
      await api.triggerEdit(wf.streamerHandle, review.clipId.replace(/\.edited\.[^.]+$/, '.mp4'));
      setPendingReview(wf.id, null);
      pushToast('redo queued', wf.id);
    } catch (e) {
      pushToast(`redo failed: ${(e as Error).message.slice(0, 80)}`, wf.id);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-ink-950/70 backdrop-blur-sm">
      <div className="w-[480px] rounded-2xl border border-ink-800 bg-ink-900 p-6 shadow-2xl shadow-black/60">
        <div className="text-[11px] uppercase tracking-[0.14em] text-ink-500">manual review</div>
        <div className="mt-1 text-sm text-ink-200">approve the edited clip before publish.</div>
        {review.clipUrl && (
          <video src={review.clipUrl} controls className="mt-4 w-full rounded-lg border border-ink-800 bg-black" />
        )}
        <label className="mt-4 block text-[11px] uppercase tracking-[0.14em] text-ink-500">title</label>
        <input className="mt-1 w-full bg-ink-950 border border-ink-800 rounded-md px-2.5 py-1.5 text-sm focus:outline-none focus:border-accent-500" value={title} onChange={(e) => setTitle(e.target.value)} />
        <label className="mt-3 block text-[11px] uppercase tracking-[0.14em] text-ink-500">description</label>
        <textarea rows={3} className="mt-1 w-full bg-ink-950 border border-ink-800 rounded-md px-2.5 py-1.5 text-sm focus:outline-none focus:border-accent-500 resize-none" value={desc} onChange={(e) => setDesc(e.target.value)} />
        <div className="mt-5 flex justify-end gap-2">
          <button onClick={redo} disabled={busy} className="text-xs px-3 py-1.5 rounded-md bg-ink-800 hover:bg-ink-700 text-ink-200 disabled:opacity-40">redo</button>
          <button onClick={approve} disabled={busy} className="text-xs px-3 py-1.5 rounded-md bg-signal-on hover:brightness-110 text-ink-950 font-medium disabled:opacity-40">{busy ? 'publishing…' : 'approve & publish'}</button>
        </div>
      </div>
    </div>
  );
}
